import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import cn from 'classnames';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useRootSelector } from '../../../../../../store/hooks';
import { selectOptions } from '../../../../../../store/features/options';
import Button from '../../../../shared/library/Button';
import { MuiStack } from '../../../../../../modules/material';
import { MobileContainer, StyledIconButton } from './styles';

export default function SidebarButtons() {
  const { t } = useTranslation();
  const [isClosed, setIsClosed] = useState<boolean>(false);
  const {
    inGoConfig: { enabled: inGoEnabled },
  } = useRootSelector(selectOptions);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const nextStepSubPath = inGoEnabled
    ? '/social-checkout'
    : '/confirm-purchase';

  const handleCloseButton = () => {
    setIsClosed(!isClosed);
  };

  return (
    <>
      {!isMobile && (
        <MuiStack spacing={2}>
          <Button
            href={nextStepSubPath}
            pathPrefix="purchase"
            color="primary"
            fullWidth
          >
            {t('site.pricing.basket.button.checkout.label')}
          </Button>

          <Button
            href="/view-basket"
            pathPrefix="purchase"
            color="primary"
            variant="outlined"
            fullWidth
          >
            {t('site.pricing.view-basket')}
          </Button>
        </MuiStack>
      )}

      {isMobile && (
        <MobileContainer className={cn({ closed: isClosed })}>
          <StyledIconButton onClick={handleCloseButton}>
            {isClosed ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </StyledIconButton>
          <Button href={nextStepSubPath} pathPrefix="purchase" color="primary">
            {t('site.pricing.basket.button.checkout.label')}
          </Button>

          <Button
            href="/view-basket"
            pathPrefix="purchase"
            color="primary"
            variant="outlined"
          >
            {t('site.pricing.view-basket')}
          </Button>
        </MobileContainer>
      )}
    </>
  );
}
